module.exports = __webpack_public_path__ + "static/img/3c1.6f61c36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/3c/3c1.png
// module id = l+/N
// module chunks = 0